<template>
  <div class="waitingPage">
    <img :src="waiting" class="waiting" />
    <div class="tips">页面正在努力完善中 ...</div>
  </div>
</template>

<script type="text/javascript">
import waiting from "../../assets/img/admin/waiting.png";
export default {
  name: "waiting",
  data() {
    return {
      waiting: waiting,
    };
  },
};
</script>

<style scoped>
.waitingPage {
  -moz-user-select: none;
  /*火狐*/
  -webkit-user-select: none;
  /*webkit浏览器*/
  -ms-user-select: none;
  /*IE10*/
  -khtml-user-select: none;
  /*早期浏览器*/
  user-select: none;
}
.waiting {
  margin: 100px auto 0 auto;
  width: 310px;
  height: 312px;
}
.tips {
  margin: 37px auto 0 auto;
  font-size: 26px;
  font-family: AlibabaPuHuiTiR;
  font-weight: 400;
  color: #838383;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/waiting.vue